<template>
  <header class="mb-66">
    <div id="container-fixed-top" class="fixed-top">
      <div id="skip">
        <a href="#content">Skip Navigation Links</a>
      </div>

      <div class="csub-alert" v-if="alert.status">
        <div id="csub-alert-content" class="p-2 text-center" v-html="alert.message"></div>
      </div>

      <nav class="navbar-main navbar navbar-light scrolled-nav" aria-label="Main navigation">
        <a class="navbar-brand py-0" href="/"><img src="@/assets/images/csub-logo-header.svg" alt="CSU Bakersfield" /></a>

        <div class="top-nav-container d-block">
          <nav class="navbar navbar-expand-lg top-nav" aria-label="CSUB website menu">
            <div class="collapse navbar-collapse">
              <ul id="header-1-nav" class="navbar-nav me-auto align-items-center">
                <li class="nav-item">
                  <a class="nav-link hvr-underline-from-center" href="/apply.shtml">Apply</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link hvr-underline-from-center" href="/visit.shtml">Visit</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link hvr-underline-from-center" href="/contact.shtml">Contact</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link hvr-underline-from-center" href="https://give.csub.edu/give.shtml">Give</a>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        <!--Search-->
        <button @click="toggleSearch" id="search-icon" class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#search" aria-controls="search" aria-expanded="false" aria-label="Toggle navigation">
          <i class="white fas fa-search"></i>
        </button>

        <div class="navbar-collapse collapse px-3" id="search">
          <form id="search-form" name="cse" action="/search/search.html" method="get">
            <div class="form-check form-check-inline position-relative me-0">
              <label for="search-input" class="d-none">Search</label>
              <input id="search-input" class="form-control pe-5" name="q" type="search" placeholder="Search CSUB.edu..." title="Type a word or phrase to search" aria-label="Search" />
              <button id="search-button" class="btn btn-secondary" type="submit" aria-label="Submit"><i class="fas fa-search"></i></button>
            </div>
            <input name="access" type="hidden" value="p" />
            <input name="site" type="hidden" value="csub" />
            <input name="output" type="hidden" value="xml_no_dtd" />
            <input name="client" type="hidden" value="csub-edu" />
            <input name="proxystylesheet" type="hidden" value="csub-edu" />
            <input name="oe" type="hidden" value="UTF-8" />
          </form>
        </div>

        <!--Hamburger-->
        <button @click="toggleHamburger" id="hamburger-icon" class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#main-nav" aria-controls="main-nav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="icon-bar top-bar"></span>
          <span class="icon-bar middle-bar"></span>
          <span class="icon-bar bottom-bar"></span>
        </button>

        <!--Mega Menu-->
        <div class="navbar-collapse collapse" id="main-nav">
          <div class="navbar-nav navbar-nav-expanded me-auto" id="main-nav-list">
            <div id="main-nav-accordion">
              <!--Begin accordion-->
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <!--Menu list 1-->
                    <ul class="main-nav-header col-12 col-md-3 list-unstyled">
                      <li class="item-level-1 nav-item">
                        <!--Output level 1 accordion heading-->
                        <div class="nav-accordion-header-level-1" id="main-nav-heading-1-level-1">
                          <a class="nav-accordion-link-level-1 text-decoration-none link-text d-block" role="button" data-bs-toggle="collapse" aria-expanded="false" href="#main-nav-collapse-1-level-1" aria-controls="main-nav-collapse-1-level-1"><span class="link-text nav-heading">Discover CSUB</span></a>
                        </div>
                        <!--Output level 2 items-->
                        <ul class="nav-accordion-collapse-level-1 collapsible collapse list-unstyled subnav-main-nav" id="main-nav-collapse-1-level-1" aria-labelledby="main-nav-heading-1-level-1">
                          <!--Begin level 2 menu items-->
                          <li class="item-level-2 nav-item">
                            <a href="/about" class="nav-link">About CSUB</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/president" class="nav-link">Administration</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/brand" class="nav-link">CSUB Brand</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/about/history" class="nav-link">CSUB History</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/rise" class="nav-link">The Campaign for CSUB</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/outreach/tours/index.html" class="nav-link">Visiting CSUB</a>
                          </li>
                          <!--End level 2 menu items-->
                        </ul>
                      </li>
                    </ul>
                    <!--End menu list 1-->

                    <!--Menu list 2-->
                    <ul class="main-nav-header col-12 col-md-3 list-unstyled">
                      <li class="item-level-1 nav-item">
                        <!--Output level 1 accordion heading-->
                        <div class="nav-accordion-header-level-1" id="main-nav-heading-2-level-1">
                          <a class="nav-accordion-link-level-1 text-decoration-none link-text d-block" role="button" data-bs-toggle="collapse" aria-expanded="false" href="#main-nav-collapse-2-level-1" aria-controls="main-nav-collapse-2-level-1"><span class="link-text nav-heading">Academics</span></a>
                        </div>
                        <!--Output level 2 items-->
                        <ul class="nav-accordion-collapse-level-1 collapsible collapse list-unstyled subnav-main-nav" id="main-nav-collapse-2-level-1" aria-labelledby="main-nav-heading-2-level-1">
                          <!--Begin level 2 menu items-->
                          <li class="item-level-2 nav-item">
                            <a href="/calendars/academic" class="nav-link">Academic Calendars</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="https://programmap.csub.edu/" class="nav-link">Academic Roadmaps</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/academics/majors_degrees/index.html" class="nav-link">Majors and Degree Programs</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/provost/index.html" class="nav-link">Provost Office</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/success/" class="nav-link">Student Success</a>
                          </li>
                          <!--End level 2 menu items-->
                        </ul>
                      </li>
                    </ul>
                    <!--End menu list 2-->

                    <!--Menu list 3-->
                    <ul class="main-nav-header col-12 col-md-3 list-unstyled">
                      <li class="item-level-1 nav-item">
                        <!--Output level 1 accordion heading-->
                        <div class="nav-accordion-header-level-1" id="main-nav-heading-3-level-1">
                          <a class="nav-accordion-link-level-1 text-decoration-none link-text d-block" role="button" data-bs-toggle="collapse" aria-expanded="false" href="#main-nav-collapse-3-level-1" aria-controls="main-nav-collapse-3-level-1"><span class="link-text nav-heading">Admissions &amp; Aid</span></a>
                        </div>
                        <!--Output level 2 items-->
                        <ul class="nav-accordion-collapse-level-1 collapsible collapse list-unstyled subnav-main-nav" id="main-nav-collapse-3-level-1" aria-labelledby="main-nav-heading-3-level-1">
                          <!--Begin level 2 menu items-->
                          <li class="item-level-2 nav-item">
                            <a href="/admissions/" class="nav-link">Admissions</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/financial-aid" class="nav-link">Financial Aid</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/registrar" class="nav-link">Office of the Registrar</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/financial-aid/types/scholarships" class="nav-link">Scholarships</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/financial-aid/costs/budgets" class="nav-link">Tuition and Fees</a>
                          </li>
                          <!--End level 2 menu items-->
                        </ul>
                      </li>
                    </ul>
                    <!--End menu list 3-->

                    <!--Menu list 4-->
                    <ul class="main-nav-header col-12 col-md-3 list-unstyled">
                      <li class="item-level-1 nav-item">
                        <!--Output level 1 accordion heading-->
                        <div class="nav-accordion-header-level-1" id="main-nav-heading-4-level-1">
                          <a class="nav-accordion-link-level-1 text-decoration-none link-text d-block" role="button" data-bs-toggle="collapse" aria-expanded="false" href="#main-nav-collapse-4-level-1" aria-controls="main-nav-collapse-4-level-1"><span class="link-text nav-heading">Student Life</span></a>
                        </div>
                        <!--Output level 2 items-->
                        <ul class="nav-accordion-collapse-level-1 collapsible collapse list-unstyled subnav-main-nav" id="main-nav-collapse-4-level-1" aria-labelledby="main-nav-heading-4-level-1">
                          <!--Begin level 2 menu items-->
                          <li class="item-level-2 nav-item">
                            <a href="https://www.gorunners.com/" class="nav-link">Athletics</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/bas/police/index.html" class="nav-link">Campus Safety</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/dining-and-housing" class="nav-link">Dining and Housing</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/recreation-wellness" class="nav-link">Recreation and Wellness</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/studentinvolvement" class="nav-link">Student Involvement</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/studentservices" class="nav-link">Student Support Services</a>
                          </li>
                          <!--End level 2 menu items-->
                        </ul>
                      </li>
                    </ul>
                    <!--End menu list 4-->

                    <!--Menu list 5-->
                    <ul class="main-nav-header col-12 col-md-3 list-unstyled">
                      <li class="item-level-1 nav-item">
                        <!--Output level 1 accordion heading-->
                        <div class="nav-accordion-header-level-1" id="main-nav-heading-5-level-1">
                          <a class="nav-accordion-link-level-1 text-decoration-none link-text d-block" role="button" data-bs-toggle="collapse" aria-expanded="false" href="#main-nav-collapse-5-level-1" aria-controls="main-nav-collapse-5-level-1"><span class="link-text nav-heading">Connect with CSUB</span></a>
                        </div>
                        <!--Output level 2 items-->
                        <ul class="nav-accordion-collapse-level-1 collapsible collapse list-inline list-unstyled subnav-main-nav" id="main-nav-collapse-5-level-1" aria-labelledby="main-nav-heading-5-level-1">
                          <!--Begin level 2 menu items-->
                          <li class="item-level-2 nav-item">
                            <a href="https://www.facebook.com/csubakersfield" class="nav-link"><i class="fab fa-facebook-square"></i> Facebook</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="https://twitter.com/csubakersfield" class="nav-link"><i class="fab fa-twitter-square"></i> Twitter</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="https://www.instagram.com/csubakersfield/" class="nav-link"><i class="fab fa-instagram"></i> Instagram</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="https://www.youtube.com/user/CSUBakersfield" class="nav-link"><i class="fab fa-youtube-square"></i> YouTube</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="https://www.linkedin.com/school/california-state-university-bakersfield" class="nav-link"><i class="fab fa-linkedin"></i> LinkedIn</a>
                          </li>
                          <!--End level 2 menu items-->
                        </ul>
                      </li>
                    </ul>
                    <!--End menu list 5-->

                    <!--Menu list 6-->
                    <ul class="main-nav-header col-12 col-md-3 list-unstyled">
                      <li class="item-level-1 nav-item">
                        <!--Output level 1 accordion heading-->
                        <div class="nav-accordion-header-level-1" id="main-nav-heading-6-level-1">
                          <a class="nav-accordion-link-level-1 text-decoration-none link-text d-block" role="button" data-bs-toggle="collapse" aria-expanded="false" href="#main-nav-collapse-6-level-1" aria-controls="main-nav-collapse-6-level-1"><span class="link-text nav-heading">News &amp; Events</span></a>
                        </div>
                        <!--Output level 2 items-->
                        <ul class="nav-accordion-collapse-level-1 collapsible collapse list-unstyled subnav-main-nav" id="main-nav-collapse-6-level-1" aria-labelledby="main-nav-heading-6-level-1">
                          <!--Begin level 2 menu items-->
                          <li class="item-level-2 nav-item">
                            <a href="https://news.csub.edu/" class="nav-link">Find Stories</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/marcomm" class="nav-link">Media Inquiries</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/eventscalendar/" class="nav-link">Featured Events</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/calendar" class="nav-link">CSUB Calendars</a>
                          </li>
                          <!--End level 2 menu items-->
                        </ul>
                      </li>
                    </ul>
                    <!--End menu list 6-->

                    <!--Menu list 7-->
                    <ul class="main-nav-header col-12 col-md-3 list-unstyled bg-color-10 px-md-3">
                      <li class="item-level-1 nav-item">
                        <!--Output level 1 accordion heading-->
                        <div class="nav-accordion-header-level-1" id="main-nav-heading-7-level-1">
                          <a class="nav-accordion-link-level-1 text-decoration-none link-text d-block" role="button" data-bs-toggle="collapse" aria-expanded="false" href="#main-nav-collapse-7-level-1" aria-controls="main-nav-collapse-7-level-1"><span class="link-text nav-heading">Just for You</span></a>
                        </div>
                        <!--Output level 2 items-->
                        <ul class="nav-accordion-collapse-level-1 collapsible collapse list-unstyled subnav-main-nav" id="main-nav-collapse-7-level-1" aria-labelledby="main-nav-heading-7-level-1">
                          <!--Begin level 2 menu items-->
                          <li class="item-level-2 nav-item">
                            <a href="/future-students" class="nav-link">Future Students</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/current-students" class="nav-link">Current Students</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/parents" class="nav-link">Parents</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/faculty-and-staff" class="nav-link">Faculty and Staff</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/alumni" class="nav-link">Alumni</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/community" class="nav-link">Community</a>
                          </li>
                          <!--End level 2 menu items-->
                        </ul>
                      </li>
                    </ul>
                    <!--End menu list 7-->

                    <!--Menu list 8-->
                    <ul class="main-nav-header col-12 col-md-3 list-unstyled">
                      <li class="item-level-1 nav-item">
                        <!--Output level 1 accordion heading-->
                        <div class="nav-accordion-header-level-1" id="main-nav-heading-8-level-1">
                          <a class="nav-accordion-link-level-1 text-decoration-none link-text d-block" role="button" data-bs-toggle="collapse" aria-expanded="false" href="#main-nav-collapse-8-level-1" aria-controls="main-nav-collapse-8-level-1"><span class="link-text nav-heading">Resources</span></a>
                        </div>
                        <!--Output level 2 items-->
                        <ul class="nav-accordion-collapse-level-1 collapsible collapse list-unstyled subnav-main-nav" id="main-nav-collapse-8-level-1" aria-labelledby="main-nav-heading-8-level-1">
                          <!--Begin level 2 menu items-->
                          <li class="item-level-2 nav-item">
                            <a href="/accesscsub/" class="nav-link">AccessCSUB</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/bookstore/" class="nav-link">Bookstore</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="https://o365.csub.edu/" class="nav-link">Email</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="https://library.csub.edu/" class="nav-link">Library</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="https://my.csub.edu/" class="nav-link">myCSUB</a>
                          </li>
                          <li class="item-level-2 nav-item">
                            <a href="/sitemap" class="nav-link">Sitemap</a>
                          </li>
                          <!--End level 2 menu items-->
                        </ul>
                      </li>
                    </ul>
                    <!--End menu list 8-->
                  </div>
                </div>
              </div>
              <!--End accordion-->
            </div>
            <!--End yamm-content-->

            <!--CTAs-->
            <div id="main-nav-ctas" class="row link-text text-md-center">
              <div class="col-12">
                <ul class="row list-inline mb-0">
                  <li class="col-12 col-md-3 white bg-color-7 px-md-0"><a href="/apply" class="text-decoration-none d-block py-2">Apply</a></li>
                  <li class="col-12 col-md-3 white bg-color-1 px-md-0"><a href="/visit" class="text-decoration-none d-block py-2">Visit</a></li>
                  <li class="col-12 col-md-3 white bg-color-11 px-md-0"><a href="/contact" class="text-decoration-none d-block py-2">Contact</a></li>
                  <li class="col-12 col-md-3 white bg-color-12 px-md-0"><a href="https://give.csub.edu/give.shtml" class="text-decoration-none d-block py-2">Give</a></li>
                </ul>
              </div>
            </div>
          </div>
          <!--End navbar-->
        </div>
      </nav>

      <!--Sub-Navigation-->
      <section class="subnav-section d-block" id="audience-menu">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 px-0">
              <div class="container-fluid p-0 line-height-1">
                <div class="col-12 px-0">
                  <!--DESKTOP-->
                  <nav aria-label="Audience menu" class="navbar navbar-expand-lg p-0 d-none d-lg-block">
                    <div id="subnav-audience-desktop" class="collapse navbar-collapse">
                      <ul class="navbar-nav align-items-center">
                        <li id="subnav-audience-desktop-label-container" class="d-block position-relative ps-3 pe-4 black bg-csub-gold text-uppercase fw-bold"><span id="subnav-audience-desktop-label" v-html="nav_label"></span>
                          <div id="arrow-audience-right" class="position-absolute"></div>
                        </li>
                        <li class="nav-item py-2" v-for="(link, index) in nav_links" v-bind:key="index"><a :href="link.URL" aria-current="page" class="nav-link hvr-underline-from-center">{{ link.title }}</a></li>
                      </ul>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--MOBILE-->
        <nav aria-label="Audience menu" class="navbar-secondary-mobile d-block d-lg-none">
          <button @click="toggleSubNav" type="button" data-bs-toggle="collapse" data-bs-target="#audience-menu-mobile" aria-controls="audience-menu-mobile" aria-expanded="false" aria-label="Toggle navigation" class="subnav-toggler black bg-csub-gold text-uppercase fw-bold navbar-toggler collapsed" v-html="nav_label">
          </button>
          <div id="audience-menu-mobile" class="subnav-mobile collapse navbar-collapse justify-content-md-center" style="max-height: 481px;">
            <ul class="navbar-nav navbar-nav-expanded me-auto">
              <li class="nav-item" v-for="(link, index) in nav_links" v-bind:key="index"><a :href="link.URL" class="nav-link">{{ link.title }}</a></li>
            </ul>
          </div>
        </nav>
      </section>
    </div>
  </header>
</template>

<script>
import axios from 'axios'
export default {
  props: {
    root: String
  },
  name: 'Page-Header',
  data () {
    return {
      nav_label: '',
      nav_links: [],
      alert: []
    }
  },

  async created () {
    const { data: jsonData } = await axios.get(this.root + '/library/static/data/page-navigation.json?nocache' + (new Date()).getTime())
    this.nav_label = jsonData.nav_links.title
    this.nav_links = jsonData.nav_links.links

    const { data: alertData } = await axios.get(this.root + '/library/static/data/alert.json?nocache' + (new Date()).getTime())
    this.alert = alertData

    window.addEventListener('load', this.mainNavOnLoad)
    window.addEventListener('resize', this.mainNavOnResize)
  },
  unmounted: function () {
    window.removeEventListener('load', this.mainNavOnLoad)
    window.addEventListener('resize', this.mainNavOnResize)
  },
  watch: {
    '$route.params': { // Expand main nav accordion if router is clicked
      handler () {
        this.mainNavOnLoad()
      },
      immediate: true
    }
  },
  updated: function () {
    this.$nextTick(function () {
      this.mainNavOnLoad()
    })

    this.mainNavOnLoad()
  },
  methods: {
    toggleHamburger: function () { // Add body overlay if hamburger icon is clicked
      const overlay = document.querySelector('.overlay')
      const search = document.querySelector('#search')
      const audienceMenuMobile = document.querySelector('#audience-menu-mobile')

      if (overlay.classList.contains('enabled') && !search.classList.contains('show') && !audienceMenuMobile.classList.contains('show')) {
        overlay.classList.remove('enabled')
      } else {
        overlay.classList.add('enabled')
      }

      if (search.classList.contains('show')) {
        search.classList.remove('show')
      }

      if (audienceMenuMobile.classList.contains('show')) {
        audienceMenuMobile.classList.remove('show')
      }
    },
    toggleSearch: function () { // Add body overlay if search icon is clicked
      const overlay = document.querySelector('.overlay')
      const mainNav = document.querySelector('#main-nav')
      const hamburgerIcon = document.querySelector('#hamburger-icon')
      const audienceMenuMobile = document.querySelector('#audience-menu-mobile')

      if (overlay.classList.contains('enabled') && !mainNav.classList.contains('show') && !audienceMenuMobile.classList.contains('show')) {
        overlay.classList.remove('enabled')
      } else {
        overlay.classList.add('enabled')
      }

      if (mainNav.classList.contains('show')) {
        mainNav.classList.remove('show')
        hamburgerIcon.classList.add('collapsed')
      }

      if (audienceMenuMobile.classList.contains('show')) {
        audienceMenuMobile.classList.remove('show')
      }
    },
    toggleSubNav: function () { // Add body overlay if subav toggler is clicked
      const overlay = document.querySelector('.overlay')
      const mainNav = document.querySelector('#main-nav')
      const hamburgerIcon = document.querySelector('#hamburger-icon')
      const search = document.querySelector('#search')

      if (overlay.classList.contains('enabled')) {
        overlay.classList.remove('enabled')
      } else {
        overlay.classList.add('enabled')
      }

      if (search.classList.contains('show')) {
        search.classList.remove('show')
      }

      if (mainNav.classList.contains('show')) {
        mainNav.classList.remove('show')
        hamburgerIcon.classList.add('collapsed')
      }
    },
    mainNavOnLoad: function () { // Expand main nav accordion on tablet and up
      const navAccordionLinkLevel1 = document.querySelectorAll('a.nav-accordion-link-level-1')
      const navAccordionCollapseLevel1 = document.querySelectorAll('ul.nav-accordion-collapse-level-1')

      if (window.innerWidth >= 768) {
        for (let i = 0; i < navAccordionLinkLevel1.length; ++i) {
          navAccordionLinkLevel1[i].setAttribute('aria-expanded', 'true')
          navAccordionLinkLevel1[i].removeAttribute('data-bs-toggle')
        }

        for (let i = 0; i < navAccordionCollapseLevel1.length; ++i) {
          navAccordionCollapseLevel1[i].setAttribute('aria-expanded', 'true')
          navAccordionCollapseLevel1[i].removeAttribute('data-bs-toggle')
          navAccordionCollapseLevel1[i].classList.add('show')
        }
      } else {
        for (let i = 0; i < navAccordionLinkLevel1.length; ++i) {
          navAccordionLinkLevel1[i].setAttribute('data-bs-toggle', 'collapse')
        }

        for (let i = 0; i < navAccordionCollapseLevel1.length; ++i) {
          navAccordionCollapseLevel1[i].setAttribute('data-parent', '#main-nav-accordion')
        }
      }
    },
    mainNavOnResize: function () { // Adjust main nav on window resize
      const navAccordionLinkLevel1 = document.querySelectorAll('a.nav-accordion-link-level-1')
      const navAccordionCollapseLevel1 = document.querySelectorAll('ul.nav-accordion-collapse-level-1')

      if (window.innerWidth >= 768) {
        for (let i = 0; i < navAccordionLinkLevel1.length; ++i) {
          navAccordionLinkLevel1[i].setAttribute('aria-expanded', 'true')
          navAccordionLinkLevel1[i].removeAttribute('data-bs-toggle')
        }

        for (let i = 0; i < navAccordionCollapseLevel1.length; ++i) {
          navAccordionCollapseLevel1[i].classList.add('show')
          navAccordionCollapseLevel1[i].setAttribute('data-parent', '')
        }
      } else {
        for (let i = 0; i < navAccordionLinkLevel1.length; ++i) {
          navAccordionLinkLevel1[i].setAttribute('aria-expanded', 'false')
          navAccordionLinkLevel1[i].setAttribute('data-bs-toggle', 'collapse')
        }

        for (let i = 0; i < navAccordionCollapseLevel1.length; ++i) {
          navAccordionCollapseLevel1[i].classList.remove('show')
          navAccordionCollapseLevel1[i].setAttribute('data-parent', '#main-nav-accordion')
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #container-fixed-top {
    z-index: 10;
  }
</style>
